export default "__VITE_ASSET__D2n0gPaw__"